var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.visible !== false)?_c('div',{staticClass:"dynamic-component"},[_c(_vm.componentName,{tag:"component",attrs:{"config":_vm.config.data || {},"priceData":_vm.priceData},on:{"action":_vm.handleAction,"submit":_vm.handleSubmit}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }